import { MRT_TableContainer, useMaterialReactTable } from 'material-react-table';

const SortableTable = ({ data, columns, dragEnd }) => {
    const table = useMaterialReactTable({
        autoResetPageIndex: false,
        columns,
        data,
        enableRowOrdering: true,
        enableSorting: false,
        enablePagination: false,
        enableStickyHeader: true,
        enableColumnActions: false,
        muiRowDragHandleProps: {
            onDragEnd: () => {
                const { draggingRow, hoveredRow } = table.getState();
                if (hoveredRow && draggingRow && draggingRow.index !== hoveredRow.index) {
                    dragEnd(draggingRow.index, hoveredRow.index);
                }
            },
        },
        muiTableContainerProps: {
            sx: {
                maxHeight: "70vh",
                overflowX:"auto"
            }
        }
    });

    return <MRT_TableContainer table={table} />
}

export default SortableTable;